module.exports = __webpack_public_path__ + "static/media/marina.8d306cee.jpg";